import { type FC } from 'react';
import { UiHStack, type UiHStackProps, UiImage, UiLink, uiStyles, UiText } from '@/lib/ui';

export interface BrandFooterProps extends UiHStackProps {
}

const BrandFooter: FC<BrandFooterProps> = (props) => {
  return (
    <UiHStack
      // bgColor={'#fff'}
      // borderTopWidth={'1px'}
      // borderStyle={'solid'}
      // borderColor={'gray.100'}
      flexGrow={1}
      opacity={{base: 0.8, lg: 1}}
      // py={4}
      justifyContent={'space-around'}
      {...props}
    >
      <UiLink href={'https://evexus.com'} target={'_blank'} {...uiStyles.hover}>
        <UiHStack spacing={1}>
          <UiText variant={'body2'} fontSize={{base: 'xs', lg: 'sm'}}>By</UiText>
          <UiImage
            src={'/event/image/brand/logo.svg'}
            minHeight={{base: '14px', lg: '18px'}}
            maxHeight={{base: '14px', lg: '18px'}}
          />
        </UiHStack>
      </UiLink>
    </UiHStack>
  );
};

export default BrandFooter;
